import { render } from "./tenantResp.vue?vue&type=template&id=bfab49de&scoped=true"
import script from "./tenantResp.vue?vue&type=script&lang=js"
export * from "./tenantResp.vue?vue&type=script&lang=js"

import "./tenantResp.vue?vue&type=style&index=0&id=bfab49de&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfab49de"]])

export default __exports__